/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { StyledModal, ModalActions, Button } from 'sarsaparilla';

interface NewsletterModalProps {
    isModalOpen: boolean;
    closeModal: () => void;
}

export function NewsletterModal({ isModalOpen, closeModal }: NewsletterModalProps) {
    return (
        <StyledModal
            shouldActionsStickInMobile
            shouldShowCloseButton={false}
            size="sm"
            isOpen={isModalOpen}
            heading="Thanks for signing up!"
            onRequestClose={closeModal}
        >
            <p className="text-md">
                You’ve been added to our mailing list, so be on the lookout for
                inspiration in your inbox.
            </p>

            <ModalActions>
                <Button onClick={closeModal}>Ok</Button>
            </ModalActions>
        </StyledModal>
    );
}
